module.exports = __webpack_public_path__ + "static/media/3.b6f92d7e.png";